import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";

const defaultData = [
  { day: "Mon", revenue: 1200 },
  { day: "Tue", revenue: 2100 },
  { day: "Wed", revenue: 1800 },
  { day: "Thu", revenue: 2400 },
  { day: "Fri", revenue: 3200 },
  { day: "Sat", revenue: 2800 },
  { day: "Sun", revenue: 3500 },
];

export default function SalesChart({ data = defaultData, loading = false }) {
  if (loading) {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ height: 300 }}
      >
        <div className="spinner-border text-primary" />
      </div>
    );
  }

  return (
    <div style={{ width: "100%", height: 300 }}>
      <ResponsiveContainer>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="day" />
          <YAxis />
          <Tooltip
            formatter={(value) => [`ETB ${value}`, "Revenue"]}
            contentStyle={{
              borderRadius: 12,
              border: "none",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          />
          <Line
            type="monotone"
            dataKey="revenue"
            stroke="#0d6efd"
            strokeWidth={3}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
